export type MemoizeFunction = <T extends (...args: any[]) => any>(fn: T) => (...args: Parameters<T>) => ReturnType<T>

interface Memoize {
    memoize: MemoizeFunction
}

export const createMemo = (): Memoize => {
    const memo = new Map()
    const memoize: MemoizeFunction = fn => {
        return (...args) => {
            const key = `${fn.name}_${JSON.stringify(args)}`

            if (memo.has(key)) {
                return memo.get(key)
            }

            const result = fn(...args)
            memo.set(key, result)
            return result
        }
    }

    return {
        memoize
    }
}
